import { useEffect, useState } from "react";
import { adminApi, errMsg } from "../api";
import { Field, TextInput, UploadButton } from "../components";
import { toast } from "../../components/ui/sonner";

const BLANK = { path: "", title: "", description: "", og_title: "", og_description: "", og_image_media_id: "", canonical: "" };
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SeoAdmin() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => adminApi.get("/admin/seo").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { id, ...payload } = edit;
      await adminApi.put("/admin/seo", payload);
      toast.success("SEO entry saved");
      setEdit(null);
      load();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  const remove = async (path) => {
    if (!window.confirm(`Remove SEO entry for ${path}?`)) return;
    try { await adminApi.delete(`/admin/seo?path=${encodeURIComponent(path)}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const set = (k, v) => setEdit((x) => ({ ...x, [k]: v }));

  return (
    <div data-testid="admin-seo-page">
      <div className="adm-head">
        <div><h1>SEO manager</h1><div className="sub">Per-path titles, meta descriptions, Open Graph, canonical</div></div>
        <button className="adm-btn primary" onClick={() => setEdit({ ...BLANK })} data-testid="add-seo">+ New entry</button>
      </div>

      {edit && (
        <div className="adm-card" style={{ borderColor: "var(--crimson)" }} data-testid="seo-editor">
          <h2>{edit.id ? `Edit ${edit.path}` : "New SEO entry"}</h2>
          <div className="adm-grid cols-2">
            <Field label="Path" hint="e.g. /services"><TextInput value={edit.path} onChange={(v) => set("path", v)} data-testid="seo-path" /></Field>
            <Field label="Canonical URL (optional)"><TextInput value={edit.canonical} onChange={(v) => set("canonical", v)} /></Field>
            <Field label="Title"><TextInput value={edit.title} onChange={(v) => set("title", v)} data-testid="seo-title" /></Field>
            <Field label="Meta description"><TextInput value={edit.description} onChange={(v) => set("description", v)} data-testid="seo-description" /></Field>
            <Field label="OG title"><TextInput value={edit.og_title} onChange={(v) => set("og_title", v)} /></Field>
            <Field label="OG description"><TextInput value={edit.og_description} onChange={(v) => set("og_description", v)} /></Field>
          </div>
          <Field label="OG image">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {edit.og_image_media_id && <img className="thumb" src={`${BACKEND_URL}/api/media/${edit.og_image_media_id}`} alt="" />}
              <UploadButton accept="image/*" kind="seo" onUploaded={(m) => set("og_image_media_id", m.id)} label="Upload OG image" testid="upload-og" />
              {edit.og_image_media_id && <button className="adm-btn danger sm" onClick={() => set("og_image_media_id", "")}>Remove</button>}
            </div>
          </Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button className="adm-btn ghost" onClick={() => setEdit(null)}>Cancel</button>
            <button className="adm-btn primary" onClick={save} disabled={saving} data-testid="save-seo">{saving ? "Saving…" : "Save entry"}</button>
          </div>
        </div>
      )}

      <div className="adm-card" style={{ padding: 0, overflow: "auto" }}>
        <table className="adm-table">
          <thead><tr><th>Path</th><th>Title</th><th>Description</th><th style={{ width: 150 }}></th></tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.path}>
                <td className="mono">{s.path}</td>
                <td>{s.title}</td>
                <td style={{ maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{s.description}</td>
                <td>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button className="adm-btn ghost sm" onClick={() => setEdit(s)} data-testid={`edit-seo-${s.path.replace(/\//g, "") || "home"}`}>Edit</button>
                    <button className="adm-btn danger sm" onClick={() => remove(s.path)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="adm-empty">No SEO entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
